import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=41661160&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41661160')) {
      api.createRecord('41661160', component.options)
    } else {
      api.reload('41661160', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=41661160&", function () {
      api.rerender('41661160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/occupation/edit.vue"
export default component.exports